import { Divider, Grid, Link, Typography } from "@mui/material";
import { loginApi } from "../../services/api";
import { PostLogin } from "../../services/api/routes/login";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { MainContext } from "../../main/context/MainContextProvider";
import { SignInWithMicrosoft } from "../components/SignInWithMicrosoft";
import TermsAndConditionsModal from "../components/TermsAndConditionsModal";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { MdLockOutline } from "react-icons/md";
import TextInputWithIcon from "../../main/components/TextInputIcon";
import { RiAccountCircleFill } from "react-icons/ri";
import { ErrorModal } from "../../main/components/ErrorModal";
import BaseButton from "../../main/components/BaseButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import logoRop from "../../assets/logo-rop/LogoRopLogin.png";
import { useRopV2AppNative } from "../../modules/ropv2app/context/RopV2AppNativeContext";
import { Launch as ExternalLinkIcon } from "@mui/icons-material";
import { getInitialRoute } from "../../main/router/AuthenticatedRoutes";

const schema = yup.object().shape({
  userName: yup.string().required("Necessário informar o usuário"),
  password: yup.string().required("Necessário informar a senha"),
});

export type LoginData = yup.InferType<typeof schema>;

export default function Login() {
  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);
  const [showLoginErrorModal, setShowLoginErrorModal] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const navigate = useNavigate();
  const { setUser, userIsManutencao, selectedDashboardUsina: selectedUsina, setToastNotifications } =
    useContext(MainContext);
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { pushDeviceId } = useRopV2AppNative();

  useEffect(() => {
    setToastNotifications({ notifications: [], isAdding: false });
  }, []);

  const verifyAdmin = () => {
    navigate(getInitialRoute(userIsManutencao, selectedUsina));
  };
  const onSubmit = async (data: LoginData) => {
    const user: PostLogin = {
      userName: data.userName,
      password: data.password,
      pushDeviceId: pushDeviceId || undefined,
    };

    try {
      setLoading(true);
      const userData = await loginApi.login(user);
      if (userData.userAccessToken === "") {
        //TODO: implementar condição para exibir modal de termos de uso assim que for definido o retorno da api
        setShowTermsModal(true);
        return;
      }
      // TODO: adicionar validação quando passwordReseted for setado no backend
      // if (userData.passwordReseted === true) {
      //   navigate("nova-senha");
      //   return;
      // }
      setUser(userData);
      verifyAdmin();
    } catch (error) {
      if (error instanceof Error) {
        setShowLoginErrorModal(true);
        if (error.message === "Usuário ou senha inválidos") {
        }
      }
    } finally {
      setLoading(false);
    }
  };
  const acceptTerms = () => {
    //TODO: implementar aceite dos termos assim que for definido o retorno da api
  };

  return (
    <Grid
      component={"form"}
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(onSubmit)();
      }}
      justifyContent={"center"}
      alignItems={"center"}
      container
      rowGap={2}
      maxWidth={"400px"}
    >
      <Grid item xs={10}>
        <img width={"60%"} src={logoRop} className="rounded" alt="pdf" />
      </Grid>

      <Grid item xs={10}>
        <SignInWithMicrosoft />
      </Grid>
      <Grid item xs={10}>
        <Divider>
          <Typography>ou</Typography>
        </Divider>
      </Grid>
      <Grid item xs={10}>
        <TextInputWithIcon
          startIcon={<RiAccountCircleFill />}
          required
          label="Usuário"
          fieldName="userName"
          control={control}
          errors={errors}
          style={{ width: "100%" }}
        />
      </Grid>
      <Grid item xs={10}>
        <TextInputWithIcon
          startIcon={<MdLockOutline />}
          endIcon={
            showPassword ? (
              <VisibilityIcon
                sx={{ cursor: "pointer", heigth: "20px", width: "20px" }}
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              />
            ) : (
              <VisibilityOffIcon
                sx={{ cursor: "pointer", heigth: "20px", width: "20px" }}
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              />
            )
          }
          required
          fieldName="password"
          label="Senha"
          type={showPassword ? "text" : "password"}
          control={control}
          errors={errors}
          style={{ width: "100%" }}
        />
      </Grid>
      <Grid item xs={10}>
        <BaseButton type="submit" loading={loading} title="Entrar" />
      </Grid>
      <Grid item xs={10}>
        <Link
          sx={{ cursor: "pointer" }}
          onClick={() => {
            navigate("recuperar-senha");
          }}
          variant="body2"
          underline="none"
        >
          Esqueceu sua senha ou usuário?
        </Link>
      </Grid>
      <Grid item xs={10}>
        <Link
          sx={{ cursor: "pointer" }}
          href="https://bei.eng.br/politica-de-privacidade"
          target="_blank"
          rel="noreferrer"
          variant="body2"
        >
          Política de privacidade <ExternalLinkIcon fontSize="inherit" />
        </Link>
      </Grid>
      <Grid item xs={10}>
        <Typography sx={{ marginTop: "10px", fontSize: "11px" }}>
          Rua Gonçalves Dias, 1762 - Lourdes - Belo Horizonte/MG - Brasil | CEP:
          30140-098
        </Typography>
      </Grid>
      <Grid item xs={10}>
        <Typography sx={{ marginTop: "5px", fontSize: "11px" }}>
          ROP &copy; 2024 Todos os direitos reservados
        </Typography>
      </Grid>
      <TermsAndConditionsModal
        acceptTerms={acceptTerms}
        open={showTermsModal}
        setOpen={setShowTermsModal}
      />
      <ErrorModal
        contentText="Ocorreu um erro ao tentar fazer login, tente novamente."
        open={showLoginErrorModal}
        setOpen={setShowLoginErrorModal}
        title="Erro ao fazer login"
      />
    </Grid>
  );
}
